import type { GlobalSearchResult, SearchArea, SearchByKey } from '../types/globalSearch';

export const searchByOptions: {
  value: SearchByKey;
  label: string;
}[] = [{
  value: 'all',
  label: 'All'
}, {
  value: 'nameEmail',
  label: 'Name or Email'
}, {
  value: 'phone',
  label: 'Phone Number'
}, {
  value: 'subscription',
  label: 'Subscription #'
}, {
  value: 'order',
  label: 'Order #'
}, {
  value: 'product',
  label: 'Product Name'
}, {
  value: 'club',
  label: 'Club Name'
}, {
  value: 'address',
  label: 'Address'
}];

export const searchAreas: {
  area: SearchArea;
  label: string;
  viewAllTo: string;
}[] = [{
  area: 'contacts',
  label: 'Contacts',
  viewAllTo: '/contacts'
}, {
  area: 'subscriptions',
  label: 'Subscriptions',
  viewAllTo: '/subscriptions'
}, {
  area: 'orders',
  label: 'Orders',
  viewAllTo: '/orders'
}, {
  area: 'loyalty',
  label: 'Loyalty',
  viewAllTo: '/loyalty/members'
}, {
  area: 'allocations',
  label: 'Allocations',
  viewAllTo: '/allocations'
}];

export const globalSearchIndex: GlobalSearchResult[] = [
// Contacts
{
  id: 'c-1',
  area: 'contacts',
  title: 'Sarah Johnson',
  subtitle: 'sarah.j@example.com',
  meta: '+1 (555) 123-4567',
  callFlag: 'top-customer',
  to: '/contacts/1',
  fields: {
    nameEmail: 'Sarah Johnson sarah.j@example.com',
    phone: '+1 (555) 123-4567',
    address: '123 Main St, San Francisco, CA 94102'
  }
}, {
  id: 'c-9',
  area: 'contacts',
  title: 'Sarah Larson',
  subtitle: 'sarah.larson@example.com',
  meta: '+61 412 884 210',
  callFlag: 'none',
  to: '/contacts/9',
  fields: {
    nameEmail: 'Sarah Larson sarah.larson@example.com',
    phone: '+61 412 884 210',
    address: '48 Hutt St, Adelaide, SA 5000'
  }
}, {
  id: 'c-8',
  area: 'contacts',
  title: 'Michael Brown',
  subtitle: 'michael.b@example.com',
  meta: '+61 433 102 557',
  callFlag: 'dont-call',
  to: '/contacts/8',
  fields: {
    nameEmail: 'Michael Brown michael.b@example.com',
    phone: '+61 433 102 557',
    address: '7 Collins St, Melbourne, VIC 3000'
  }
}, {
  id: 'c-7',
  area: 'contacts',
  title: 'Sophie Miller',
  subtitle: 'sophie.m@example.com',
  meta: '+61 408 661 903',
  callFlag: 'not-worth-chasing',
  to: '/contacts/7',
  fields: {
    nameEmail: 'Sophie Miller sophie.m@example.com',
    phone: '+61 408 661 903',
    address: '22 Barossa Valley Way, Tanunda, SA 5352'
  }
},
// Subscriptions
{
  id: 's-23144',
  area: 'subscriptions',
  title: 'SUB-23144',
  subtitle: 'Sarah Johnson · Premium Club · 6 Bottles Every 2 Months',
  meta: 'Next billing 5 Dec 2026',
  badge: {
    label: 'Active',
    variant: 'success'
  },
  to: '/subscriptions/SUB-23144',
  fields: {
    nameEmail: 'Sarah Johnson',
    subscription: 'SUB-23144',
    club: 'Premium Club',
    product: '2021 Barossa Shiraz 2023 Eden Valley Riesling'
  }
}, {
  id: 's-23138',
  area: 'subscriptions',
  title: 'SUB-23138',
  subtitle: 'Sarah Johnson · Reds Club · 12 Bottles Quarterly',
  meta: 'Next billing 20 Jan 2027',
  badge: {
    label: 'Active',
    variant: 'success'
  },
  to: '/subscriptions/SUB-23138',
  fields: {
    nameEmail: 'Sarah Johnson',
    subscription: 'SUB-23138',
    club: 'Reds Club',
    product: '2022 McLaren Vale Grenache 2020 Coonawarra Cabernet Sauvignon'
  }
}, {
  id: 's-23109',
  area: 'subscriptions',
  title: 'SUB-23109',
  subtitle: 'Sarah Larson · Whites Club · 3 Bottles Every Month',
  meta: 'Paused until 1 Jan 2027',
  badge: {
    label: 'Paused',
    variant: 'warning'
  },
  to: '/subscriptions/SUB-23109',
  fields: {
    nameEmail: 'Sarah Larson',
    subscription: 'SUB-23109',
    club: 'Whites Club',
    product: '2023 Adelaide Hills Chardonnay 2025 Fiano'
  }
}, {
  id: 's-23122',
  area: 'subscriptions',
  title: 'SUB-23122',
  subtitle: 'Michael Brown · Premium Club · 6 Bottles Every 2 Months',
  meta: 'Next billing 14 Jan 2027',
  badge: {
    label: 'Active',
    variant: 'success'
  },
  to: '/subscriptions/SUB-23122',
  fields: {
    nameEmail: 'Michael Brown',
    subscription: 'SUB-23122',
    club: 'Premium Club',
    product: '2021 Barossa Shiraz'
  }
},
// Orders
{
  id: 'o-4521',
  area: 'orders',
  title: '#4521',
  subtitle: 'Sarah Johnson · 12 Sep 2026',
  meta: '$486.00',
  badge: {
    label: 'Club',
    variant: 'info'
  },
  to: '/orders',
  fields: {
    nameEmail: 'Sarah Johnson',
    order: '#4521',
    product: '2021 Barossa Shiraz 2023 Eden Valley Riesling'
  }
}, {
  id: 'o-4488',
  area: 'orders',
  title: '#4488',
  subtitle: 'Sarah Johnson · 20 Jul 2026',
  meta: '$96.00',
  badge: {
    label: 'Online',
    variant: 'default'
  },
  to: '/orders',
  fields: {
    nameEmail: 'Sarah Johnson',
    order: '#4488',
    product: '2023 Adelaide Hills Chardonnay'
  }
}, {
  id: 'o-4471',
  area: 'orders',
  title: '#4471',
  subtitle: 'Sarah Larson · 2 Jul 2026',
  meta: '$118.50',
  badge: {
    label: 'Club',
    variant: 'info'
  },
  to: '/orders',
  fields: {
    nameEmail: 'Sarah Larson',
    order: '#4471',
    product: '2025 Fiano 2023 Adelaide Hills Chardonnay'
  }
}, {
  id: 'o-4402',
  area: 'orders',
  title: '#4402',
  subtitle: 'Sarah Johnson · 16 Jun 2026',
  meta: '$210.00',
  badge: {
    label: 'One-time · WinePik',
    variant: 'default'
  },
  to: '/orders',
  fields: {
    nameEmail: 'Sarah Johnson',
    order: '#4402',
    product: '2022 McLaren Vale Grenache'
  }
}, {
  id: 'o-4390',
  area: 'orders',
  title: '#4390',
  subtitle: 'Michael Brown · 10 Jun 2026',
  meta: '$252.00',
  badge: {
    label: 'Club',
    variant: 'info'
  },
  to: '/orders',
  fields: {
    nameEmail: 'Michael Brown',
    order: '#4390',
    product: '2021 Barossa Shiraz'
  }
},
// Loyalty
{
  id: 'l-1',
  area: 'loyalty',
  title: 'Sarah Johnson',
  subtitle: 'Gold tier',
  meta: '2,450 pts',
  to: '/contacts/1?tab=loyalty',
  fields: {
    nameEmail: 'Sarah Johnson sarah.j@example.com'
  }
}, {
  id: 'l-9',
  area: 'loyalty',
  title: 'Sarah Larson',
  subtitle: 'Silver tier',
  meta: '820 pts',
  to: '/contacts/9?tab=loyalty',
  fields: {
    nameEmail: 'Sarah Larson sarah.larson@example.com'
  }
}, {
  id: 'l-8',
  area: 'loyalty',
  title: 'Michael Brown',
  subtitle: 'Bronze tier',
  meta: '310 pts',
  to: '/contacts/8?tab=loyalty',
  fields: {
    nameEmail: 'Michael Brown michael.b@example.com'
  }
},
// Allocations
{
  id: 'a-1',
  area: 'allocations',
  title: '2023 Reserve Shiraz Release',
  subtitle: 'Sarah Johnson',
  badge: {
    label: 'Active',
    variant: 'success'
  },
  to: '/allocations/1',
  fields: {
    nameEmail: 'Sarah Johnson',
    product: '2023 Reserve Shiraz'
  }
}, {
  id: 'a-5',
  area: 'allocations',
  title: 'Vintner Exclusive — Museum Release',
  subtitle: 'Michael Brown',
  badge: {
    label: 'Early Access',
    variant: 'info'
  },
  to: '/allocations/5',
  fields: {
    nameEmail: 'Michael Brown',
    product: '2012 Museum Cabernet'
  }
}];
